export default "__VITE_ASSET__AjtZ7XYO__"